import { render, staticRenderFns } from "./GiftFinderProductsList.vue?vue&type=template&id=2b41c90e"
import script from "./GiftFinderProductsList.vue?vue&type=script&lang=js"
export * from "./GiftFinderProductsList.vue?vue&type=script&lang=js"
import style0 from "./GiftFinderProductsList.vue?vue&type=style&index=0&id=2b41c90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports